export const getAllUsers = (profiles, limit, offset) => {
  return `
    SELECT
        Id, 
        Name, 
        Username,
        Profile.Name, 
        Profile.Id,
        UserRole.Name, 
        UserRole.Id,
        isActive
    FROM 
        User 
    WHERE 
        profile.name IN ( ${profiles} )
        AND profile.name != null 
        AND UserRole.Name != null
        AND isActive = true
    ORDER BY 
        Name
    LIMIT ${limit}
    OFFSET ${offset}
    `;
};

export const getAllUsersAll = profiles => {
  return `
    SELECT
        Id, 
        Name, 
        Username,
        Profile.Name, 
        Profile.Id,
        UserRole.Name, 
        UserRole.Id,
        isActive
    FROM 
        User 
    WHERE 
        profile.name IN ( ${profiles} )
        AND profile.name != null 
        AND UserRole.Name != null
        AND isActive = true
    ORDER BY 
        Name
    `;
};
